import React from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import InnoIcons from "InnoUI/innoicons";
import SC from "./style";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: "linear-gradient(180deg, #e65c00 0%, #f5af19 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: "linear-gradient(180deg, #e65c00 0%, #f5af19 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
}));

const StepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 20,
  height: 20,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage: "linear-gradient(180deg, #e65c00 0%, #f5af19 100%)",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient(180deg, #e65c00 0%, #f5af19 100%)",
  }),
}));

function StepIcon(props) {
  const { active, completed, icon } = props;

  return (
    <StepIconRoot ownerState={{ active, completed }}>
      {completed ? (
        <InnoIcons.CheckIcon sx={{ fontSize: "15px" }} />
      ) : (
        <InnoIcons.AdjustIcon />
      )}
    </StepIconRoot>
  );
}

const CustomStepper = ({ steps, icons, activeStep }) => {
  return (
    <SC.StackContainer  spacing={4}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<CustomConnector />}
      >
        {steps.map((step, index) => (
          <Step key={index} sx={{ textAlign: "left" }}>
            <StepLabel
              StepIconComponent={(props) => (
                <StepIcon {...props} icon={index + 1} icons={icons} />
              )}
            >
              <SC.Heading>{step.heading}</SC.Heading>
              <SC.Description >
                {step.description}
              </SC.Description>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </SC.StackContainer>
  );
};

export default CustomStepper;
